import { DeletePeriodicCheckOutDto, DeletePeriodicCheckInDto } from '../../../types/periodic-check.dto'

export const DELETE_PERIODIC_CHECK = 'DELETE_PERIODIC_CHECK'
export const DELETE_PERIODIC_CHECK_SUCCESS = 'DELETE_PERIODIC_CHECK_SUCCESS'
export const DELETE_PERIODIC_CHECK_ERROR = 'DELETE_PERIODIC_CHECK_ERROR'
export const RESET_DELETE_PERIODIC_CHECK = 'RESET_DELETE_PERIODIC_CHECK'

export interface DeletePeriodicCheck {
  type: typeof DELETE_PERIODIC_CHECK
  payload: DeletePeriodicCheckOutDto
}

export interface DeletePeriodicCheckSuccess {
  type: typeof DELETE_PERIODIC_CHECK_SUCCESS
  payload: DeletePeriodicCheckInDto
}

export interface DeletePeriodicCheckError {
  type: typeof DELETE_PERIODIC_CHECK_ERROR
  payload: string | boolean
}

export interface ResetDeletePeriodicCheck {
  type: typeof RESET_DELETE_PERIODIC_CHECK
  payload: null
}

export interface State {
  data: DeletePeriodicCheckInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeletePeriodicCheck | DeletePeriodicCheckSuccess | DeletePeriodicCheckError | ResetDeletePeriodicCheck
